import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { PasswordService } from "../../services/password.service";
import { StringService } from "../../services/string.service";
import { BrokerService } from "../../services/broker.service";
import { ApplicationService } from "../../services/application.service";

@Component({
  selector: "app-confirm-request",
  templateUrl: "./confirm-request.component.html",
  styleUrls: ["../new-password/new-password.component.scss"],
  standalone: true,
  imports: [],
})
export class ConfirmRequestComponent implements OnInit, OnDestroy {
  private token: string;
  public application: Object = {};
  private appName: string;
  public requestSent: boolean = false;
  private subs: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private passwordService: PasswordService,
    public stringService: StringService,
    private router: Router,
    private applicationService: ApplicationService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.subs.push(
      this.stringService.connectionStringsChange.subscribe(() =>
        this.cdr.markForCheck(),
      ),
    );
    this.subs.push(
      this.stringService.change.subscribe(() => this.cdr.markForCheck()),
    );
    this.appName = this.route.snapshot.paramMap.get("application");
    if (this.appName === undefined) {
      if (
        confirm("Der opstod en fejl. Du bliver stillet tilbage til startsiden.")
      ) {
        this.router.navigate(["/"]);
      }
    }
    this.applicationService
      .getApplication(this.appName)
      .subscribe((application) => {
        this.application = application;
      });
    if (Object.length === 0) {
      this.stringService.getStrings().subscribe((response) => {
        this.stringService.toggle(response);
      });
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  public confirmRequest() {
    this.token = this.route.snapshot.paramMap.get("token");
    if (this.token !== undefined) {
      this.passwordService
        .confirmPasswordRequest(this.token)
        .subscribe((response: any) => {
          this.requestSent = true;
        });
    }
  }

  public close() {
    window.close();
  }
}
